import React from 'react';
import { Typography, TypographyProps } from '@cp/ds/src/components/typography';
import { styled } from '@cp/ds/src/theme';
import { Tokens, name } from './const';

const VacancyDescription = styled(Typography, { name, slot: 'Description' })({
  marginBlockStart: 0,
  marginBlockEnd: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: '3',
  color: Tokens.textColor(),
});

interface DescriptionProps extends TypographyProps {}
export const Description = (props: DescriptionProps) => <VacancyDescription component="p" variant="body" {...props} />;
